import { useState } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../auth/AuthContext';

export const Login = () => {
  const { state, signInWithGoogle } = useAuth();
  const [error, setError] = useState<string | null>(null);

  if (state.status === 'signed-in') {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md rounded-lg bg-white p-8 shadow">
        <h1 className="text-xl font-semibold">UZU Translator</h1>
        <p className="mt-2 text-sm text-gray-600">許可されたアカウントでログインしてください</p>

        {state.status === 'forbidden' && (
          <p className="mt-4 rounded bg-red-50 px-3 py-2 text-sm text-red-700">
            {state.email} はアクセスが許可されていません。
          </p>
        )}
        {error !== null && (
          <p className="mt-4 rounded bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>
        )}

        <button
          type="button"
          onClick={() => {
            setError(null);
            signInWithGoogle().catch((e: unknown) => {
              setError(e instanceof Error ? e.message : String(e));
            });
          }}
          disabled={state.status === 'loading'}
          className="mt-6 w-full rounded bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-gray-800 disabled:opacity-50"
        >
          Google でログイン
        </button>
      </div>
    </div>
  );
};
